
import Vue from 'vue';
import Icon from '@/pages/profile/components/icon/Icon.vue';
import { format } from 'date-fns';
import { MONTHS2 } from '@/pages/activities/const';

export default Vue.extend({
  name: 'InfoSferumWebinar',
  components: { Icon },
  props: {
    item: Object as any,
  },
  computed: {
    getCallTime() {
      const date = new Date(this.item.call_time);
      return `${date.getDate()} ${this.getMonth(date)} ${date.getFullYear()} года`;
    },
    getTime() {
      const date = new Date(this.item.call_time);
      return format(date, 'HH:mm');
    },
  },
  methods: {
    getMonth(val: Date) {
      return MONTHS2[String(val.getMonth() + 1)];
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/infoSferum/InfoSferumWebinar.vue